module.exports = __webpack_public_path__ + "static/lecciones_comunicacion-0d7c6b4d79d7bcbe0ea89ccb86cf35b4.jpg";